export default __webpack_public_path__ + "static/media/MaddieLTestimonial.7c0bb080.png";